import { use } from 'react';
import AppContext from '../app.context';
const useIsDev = () => {
    const { isDev } = use(AppContext);
    return isDev;
};
export default useIsDev;
